

































































































































































































































import VueOptions from '@utils/VueOptions'
import EditorContent from '@components/EditorContent'

settings =
  name: 'UniversityProvides'
  vue:
    props: ['offer', 'step']

    components: {
      EditorContent,
    }

    data: ->
      openPanel: null

    computed:
      activations: -> (act for name, act of @offer?.activation_snapshots)
      activation: -> @activations?[0]
      anyDataBeingCollected: ->
        collected = false
        (collected ||= value) for key, value of (@activation.attendee_data_collection.data_collected || {})
        collected

    methods:
      isProductSamplingSpace: (spaceType)->
        spaceType is 'product_sampling'
      isVideoWall: (spaceType)->
        spaceType is 'video_wall'
      isBoothSpace: (spaceType)->
        -1 isnt spaceType.indexOf 'booth'
      isFoodTruckSpace: (spaceType)->
        spaceType is 'food_truck'
      isTrailerSpace: (spaceType)->
        spaceType is 'trailer'
      isSocialMediaPost: (spaceType)->
        spaceType is 'social_media_post'

      formatSpecialRequest: (request) ->
        @$options.filters.formatTextArea request

export default VueOptions.vue settings
